import { InvalidLotNumberReason } from "@redotech/redo-fulfillment-common/lot/invalid-lot-number";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resolvePickLot = {
  name: "resolvePickLot" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    itemId: zExt.objectId(),
    lotNumber: z.string().min(1),
  }),
  output: z.object({
    success: z.boolean(),
    inventoryItemId: z.string().optional(),
    lotNumber: z.string().optional(),
    message: z.string().optional(),
    // Caught so an older tab treats a new reason as a plain refusal.
    invalidLotNumberReason: z
      .enum(InvalidLotNumberReason)
      .optional()
      .catch(undefined),
  }),
};
